import { useDispatch } from 'react-redux'
import { actions } from '..'

export const useSetStepSearch = () => {
  const dispatch = useDispatch()
  return (query: string) => {
    return dispatch(actions.setStepSearch({ value: query }))
  }
}
